<aside class="contact-dock" [attr.aria-label]="'contact.dock_label' | t">
  <a
    class="contact-dock__link"
    *ngFor="let social of links; let i = index"
    [style.--delay.ms]="80 + i * 90"
    [class.contact-dock__link--whatsapp]="social.kind === 'whatsapp'"
    [class.contact-dock__link--phone]="social.kind === 'phone'"
    [class.contact-dock__link--facebook]="social.kind === 'facebook'"
    [href]="social.isCallChooser ? null : social.href"
    [attr.role]="social.isCallChooser ? 'button' : null"
    [attr.target]="social.openInNewTab ? '_blank' : null"
    [attr.rel]="social.openInNewTab ? 'noopener noreferrer' : null"
    [attr.aria-label]="social.labelKey | t"
    [attr.aria-expanded]="social.isCallChooser ? callChooserOpen : null"
    (click)="onLinkClick($event, social)"
  >
    <img [src]="social.iconUrl" alt="" loading="lazy" decoding="async" fetchpriority="low" />
    <span class="contact-dock__label">{{ social.labelKey | t }}</span>
  </a>
</aside>

<div class="call-chooser" *ngIf="callChooserOpen" role="dialog" [attr.aria-label]="'contact.call_chooser_title' | t">
  <button type="button" class="call-chooser__backdrop" (click)="closeCallChooser()" [attr.aria-label]="'common.close' | t"></button>
  <div class="call-chooser__sheet">
    <p class="call-chooser__title">{{ 'contact.call_chooser_title' | t }}</p>
    <a class="call-chooser__option" [href]="mobileTelHref" (click)="closeCallChooser()">
      <span class="call-chooser__option-label">{{ 'contact.call_mobile' | t }}</span>
      <span class="call-chooser__option-value" dir="ltr">{{ mobileDisplay }}</span>
    </a>
    <a class="call-chooser__option" [href]="hotlineTelHref" (click)="closeCallChooser()">
      <span class="call-chooser__option-label">{{ 'contact.call_hotline' | t }}</span>
      <span class="call-chooser__option-value" dir="ltr">{{ hotlineDisplay }}</span>
    </a>
    <button type="button" class="call-chooser__cancel" (click)="closeCallChooser()">{{ 'common.cancel' | t }}</button>
  </div>
</div>
